import { isEmail, isRequired } from '../../../validation/rules';
import { ruleRunner } from '../../../validation/ruleRunner';

export const fieldValidations = [
  ruleRunner('email', 'Email', true, isRequired, isEmail)
];
